import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, Box, ResponsiveGridLayout} from 'views/components';

import PersonalHeader from './widgets/utils/dashboard_headers/PersonalHeader';
import Widget from './widgets/Widget';

import {DEFAULT_LAYOUTS} from './widgets/utils/default_layout';
import {newWidgetLocations, convertToDashboardSettings} from './widgets/utils/dashboard_settings_conversion';
import constants from './widgets/utils/constants';

import _ from 'lodash';
import {generateUuid} from 'utils/miscellaneous/uuid';

const PersonalDashboard = (props) => {
  const [editMode, setEditMode] = React.useState(false);
  const [widgetObj, setWidgetObj] = React.useState({});
  const [editWidgetObj, setEditWidgetObj] = React.useState({});

  const dashboardSetting = convertToDashboardSettings(editMode ? editWidgetObj : widgetObj);
  const localStorageKey = `CustomDashboardLayout-V2`;

  React.useEffect(() => {
    const initialWidgetObj = JSON.parse(localStorage.getItem(localStorageKey)) || DEFAULT_LAYOUTS;

    setWidgetObj(initialWidgetObj);
  }, []);

  React.useEffect(() => {
    localStorage.setItem(localStorageKey, JSON.stringify(widgetObj));
  }, [widgetObj]);

  const onLayoutChange = (newLayoutArr, newLayoutsObj) => {
    setEditWidgetObj((widgetObj) => {
      for (const [size, layouts] of Object.entries(newLayoutsObj)) {
        for (const layout of layouts) {
          if (widgetObj[layout.i]) {
            widgetObj[layout.i].location[size] = {
              x: layout.x,
              y: layout.y,
            };
          }
        }
      }
      return {...widgetObj};
    });
  };

  const onSaveLayout = () => {
    setWidgetObj(_.cloneDeep(editWidgetObj));
    setEditMode(false);
  };

  const onCancelLayout = () => {
    setEditMode(false);
  };

  const onResetLayout = () => {
    localStorage.removeItem(localStorageKey);
    setWidgetObj(DEFAULT_LAYOUTS);
    setEditMode(false);
  };

  const startEditting = (mode) => {
    setEditWidgetObj(_.cloneDeep(widgetObj));
    setEditMode(true);
  };

  const removeWidget = (id) => {
    setEditWidgetObj((e) => {
      delete e[id];
      return {...e};
    });
    setEditMode(true);
  };

  const addWidget = (widgetType) => {
    setEditWidgetObj((e) => {
      return {
        ...e,
        [generateUuid()]: {
          widgetType,
          location: newWidgetLocations(widgetType, e),
          settings: {},
        },
      };
    });
    setEditMode(true);
  };

  const saveWidgetSettings = (uuid, newSettings) => {
    setEditWidgetObj((e) => {
      return {
        ...e,
        [uuid]: {
          ...e[uuid],
          settings: newSettings,
        },
      };
    });
  };

  const settings = {
    type: 'PERSONAL',
    detail: {
      requesterRn: props.requesterRn,
    },
  };


  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PersonalHeader
          editMode={editMode}
          setEditMode={startEditting}
          onSaveLayout={onSaveLayout}
          onCancelLayout={onCancelLayout}
          onResetLayout={onResetLayout}
          addWidget={addWidget}
          settings={settings}
        />
      </Grid>
      <Grid item xs={12} >
        <ResponsiveGridLayout
          className="layout"
          layouts={dashboardSetting.layouts}
          breakpoints={{lg: 1400, md: 1000, sm: 600}}
          cols={{lg: 32, md: 24, sm: 8}}
          rowHeight={454} // Since we add 8px padding in y we need to add 16px to desired height
          margin={[10, 10]} // Margin between items [x, y] in px.
          containerPadding={[0, 0]} // Padding inside the container [x, y] in px
          onLayoutChange={onLayoutChange}
          isBounded={true}
          isResizable={false}
          measureBeforeMount={true}
          draggableHandle={`.${constants.DragHandleClassName}`}
        >
          {
            dashboardSetting.widgets.map((widget) => {
              const uuid = widget.uuid;

              return (
                <Box key={uuid}
                >
                  <Widget
                    removeWidget={removeWidget}
                    saveWidgetSettings={saveWidgetSettings}
                    editMode={editMode}
                    dashboardSettings={settings}
                    {...widget}
                  />
                </Box>
              );
            })
          }
        </ResponsiveGridLayout>
      </Grid>
    </Grid>
  );
};


PersonalDashboard.propTypes = {
  requesterRn: PropTypes.string.isRequired,
};
const mapStateToProps = (state) => ({
  requesterRn: state.user.userRn,
});

export default connect(mapStateToProps, dispatch)(React.memo(PersonalDashboard));
